import Dispatcher from '../dispatcher/CentricDispatcher.react.js';
import { ReduceStore } from 'flux/utils';
import { ActionTypes } from '../constants/CentricConstants';

const initialData = {
    errors: [],
    warnings: [],
    successCount: 0,
    totalProcessedCount: 0
};

class UserImportStore extends ReduceStore {

    getInitialState() {
        return {
            targetFile: {},
            data: initialData,
            headers: [],
            isProcessed: false,
            isSuppressedSuccessMessage: false
        };
    }

    reduce(state, action) {
        switch (action.type) {
            case ActionTypes.USER_IMPORT_SET_TARGET_FILE:
                return Object.assign({}, state, { targetFile: action.payload });

            case ActionTypes.USER_IMPORT_REQUEST:
                return Object.assign({}, state, {
                    data: initialData,
                    isProcessed: false,
                    isSuppressedSuccessMessage: true
                });

            case ActionTypes.USER_IMPORT_SUCCESS:
                return Object.assign({}, state, {
                    data: action.data,
                    isProcessed: true,
                    isSuppressedSuccessMessage: false
                });

            case ActionTypes.USER_IMPORT_FAILURE:
                return Object.assign({}, state, {
                    isProcessed: true,
                    isSuppressedSuccessMessage: false
                });

            case ActionTypes.USER_IMPORT_SET_PROCESSED:
                return Object.assign({}, state, { isProcessed: !!action.payload });

            case ActionTypes.USER_IMPORT_HEADERS_SUCCESS:
                return Object.assign({}, state, { headers: action.data });

            default:
                return state;
        }
    }
}

export default new UserImportStore(Dispatcher);
